export default "__VITE_ASSET__pyK070q3__"